<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <font-awesome-icon :icon="['fas', 'user-circle']"/>
      &nbsp;<span v-once>{{ userName }}</span>&nbsp;さん
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item @click="open2FASetting"><i class="fa fa-shield" /> 2段階認証設定</b-dropdown-item>
      <b-dropdown-item @click="openManual"><i class="fa fa-book" /> 操作マニュアル</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  props: [ 'userName' ],
  data: () => {
    return {
      itemsCount: 42
    }
  },
  methods: {
    // ログアウト実行イベント発火
    logout() {
      this.$emit("logout-on-click");
    },
    // 2022.01 2021年度保守改造 操作マニュアルメニューの追加 adsol kanamoto
    // 操作マニュアルオープン
    async openManual() {
      // マニュアルのURL
      const manualUrl = process.env.VUE_APP_MANUAL_URL
      await this.openTab(manualUrl)
    },
    // 一時的に<a>タグを作成し、クリックする
    async openTab(fileUrl) {
      const tempLink = document.createElement('a')
      document.body.appendChild(tempLink)
      tempLink.href = fileUrl
      tempLink.target = '_blank'
      tempLink.rel = 'noreferrer noopener'
      tempLink.click()
      tempLink.remove()
    },
    async open2FASetting() {
      this.$router.push({path: '/twoFactorAuthentication'})
    },
  }
}
</script>
